import React from 'react';
import './Header.css';

export default function Header({ onLogoClick }) {
  return (
    <header className="header">
      <div className="header-inner">
        <button className="logo" onClick={onLogoClick} aria-label="Go home">
          <span className="logo-icon">🍳</span>
          <span className="logo-text">
            <span className="logo-main">Flavour</span>
            <span className="logo-sub">FINDER</span>
          </span>
        </button>
        <p className="header-tagline">Discover recipes from around the world</p>
      </div>
    </header>
  );
}
